import { accountBankList } from '@/views/payment/merchantManage/request';
import { logisticsSelectList } from '@/views/claim/customerRecordManage/utils';
const statistics = [{
  id: 1,
  name: '赔付金额',
  icon: 'dollar',
  infoId: 1,
  type: 'singleLine',
  type: 'singleLine',
  statistical: 'amount'
}, {
  id: 2,
  name: '估损金额',
  icon: 'dollar',
  infoId: 1,
  type: 'singleLine',
  type: 'singleLine',
  statistical: 'amount'
}];
const control = [{
  id: 1,
  name: '单行文本',
  icon: 'snippets',
  infoId: 1,
  type: 'singleLine'
}, {
  id: 2,
  name: '多行文本',
  icon: 'snippets',
  infoId: 1,
  type: 'multiline'
}, {
  id: 3,
  name: '单选',
  icon: 'down-circle',
  type: 'singleChoice',
  infoId: 2
}, {
  id: 4,
  name: '多选',
  icon: 'down-square',
  type: 'multipleChoice',
  infoId: 2
}, {
  id: 5,
  name: '下拉选择',
  icon: 'down',
  type: 'dropDown',
  infoId: 2
}, {
  id: 6,
  name: '层级下拉',
  icon: 'down',
  type: 'hierarchy',
  infoId: 3
}, {
  id: 7,
  name: '选择日期',
  icon: 'calendar',
  type: 'date',
  infoId: 4
}, {
  id: 8,
  name: '选择日期范围',
  icon: 'calendar',
  type: 'dateRange',
  infoId: 4
}, {
  id: 9,
  name: '图片',
  icon: 'file-image',
  type: 'picture',
  infoId: 5
}, {
  id: 10,
  name: '附件',
  icon: 'file',
  type: 'enclosure',
  infoId: 5
}];
const controlGroup = [{
  id: 1,
  name: '收件信息',
  icon: '',
  type: 'controlGroup',
  category: 'receiving'
}, {
  id: 2,
  name: '寄件信息',
  icon: 'right',
  type: 'controlGroup',
  category: 'mail'
}, {
  id: 3,
  name: '收款信息',
  icon: '',
  type: 'controlGroup',
  category: 'collection'
}, {
  id: 4,
  name: '打款信息',
  icon: '',
  type: 'controlGroup',
  category: 'payment',
  infoId: 7
}, {
  id: 5,
  name: '配件明细',
  icon: 'right',
  type: 'table',
  infoId: 6,
  category: 'accessories'
}];
const fileFormat = {
  picture: ['jpg', 'pdf', 'jpeg', 'png'],
  enclosure: ['xlsx', 'xls', 'docx', 'doc', 'rm', 'mp4', 'rmvb', 'avi']
};
const controlGroupInfo = {
  receiving: {
    controlTitle: '收件信息',
    controlType: 'controlGroup',
    control: [{
      partsType: 'singleLine',
      formName: '收件信息',
      controlName: '收件人',
      promptText: '请输入收件人姓名',
      other: 1
    }, {
      partsType: 'singleLine',
      formName: '收件信息',
      controlName: '联系方式',
      promptText: '请输入联系方式',
      other: 1
    }, {
      partsType: 'singleLine',
      formName: '收件信息',
      controlName: '具体地址',
      promptText: '请输入具体地址',
      other: 1
    }, {
      partsType: 'singleLine',
      formName: '收件信息',
      controlName: '备注'
    }]
  },
  mail: {
    controlTitle: '寄件信息',
    controlType: 'controlGroup',
    control: [{
      partsType: 'dropDown',
      formName: '寄件信息',
      controlName: '物流公司',
      promptText: '请选择物流公司',
      other: 1,
      option: logisticsSelectList.join(';'),
      optionList: logisticsSelectList
    }, {
      partsType: 'singleLine',
      formName: '寄件信息',
      controlName: '运单号',
      promptText: '请输入运单号',
      other: 1
    }, {
      partsType: 'singleLine',
      formName: '寄件信息',
      controlName: '备注'
    }]
  },
  collection: {
    controlTitle: '收款信息',
    controlType: 'controlGroup',
    control: [{
      partsType: 'dropDown',
      formName: '收款信息',
      controlName: '开户银行',
      promptText: '请选择开户银行',
      other: 1,
      option: accountBankList.join(';'),
      optionList: accountBankList
    }, {
      partsType: 'singleLine',
      formName: '收款信息',
      controlName: '开户行名称',
      promptText: '请输入开户行名称'
    }, {
      partsType: 'singleLine',
      formName: '收款信息',
      controlName: '银行账号',
      promptText: '请输入银行账号',
      other: 1
    }, {
      partsType: 'singleLine',
      formName: '收款信息',
      controlName: '备注'
    }]
  },
  payment: {
    controlTitle: '付款信息',
    controlType: 'controlGroup',
    control: [{
      partsType: 'date',
      formName: '付款信息',
      controlName: '付款时间',
      other: 1,
      dateType: 1
    }, {
      partsType: 'singleLine',
      formName: '付款信息',
      controlName: '付款金额',
      promptText: '请输入付款金额',
      other: 1
    }, {
      partsType: 'singleLine',
      formName: '付款信息',
      controlName: '备注'
    }, {
      partsType: 'picture',
      formName: '付款信息',
      controlName: '付款凭证',
      fileFormat: fileFormat.picture,
      template: []
    }]
  },
  accessories: {
    controlTitle: '配件明细',
    controlType: 'table',
    operation: '',
    control: [{
      slots: {
        title: '序号'
      },
      dataIndex: 'index',
      key: '1',
      align: 'center',
      scopedSlots: {
        customRender: 'index'
      },
      width: 80
    }, {
      slots: {
        title: '零配件编码'
      },
      dataIndex: 'code',
      key: '2',
      align: 'center'
    }, {
      slots: {
        title: '配件名称'
      },
      dataIndex: 'name',
      key: '3',
      align: 'center'
    }, {
      slots: {
        title: '配件照片'
      },
      dataIndex: 'photo',
      key: '4',
      align: 'center',
      scopedSlots: {
        customRender: 'photo'
      }
    }, {
      slots: {
        title: '门店意见'
      },
      dataIndex: 'opinion',
      key: '5',
      align: 'center'
    }, {
      slots: {
        title: '价格（元）'
      },
      dataIndex: 'price',
      key: '10',
      align: 'center'
    }, {
      slots: {
        title: '备注'
      },
      dataIndex: 'remarks',
      key: '6',
      align: 'center'
    }]
  }
};
export { statistics, control, controlGroup, fileFormat, controlGroupInfo };